import { render, staticRenderFns } from "./PatientVerificationDetail.vue?vue&type=template&id=d44b2d8a&scoped=true"
import script from "./PatientVerificationDetail.vue?vue&type=script&lang=js"
export * from "./PatientVerificationDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientVerificationDetail.vue?vue&type=style&index=0&id=d44b2d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44b2d8a",
  null
  
)

export default component.exports